import axios from 'axios';
import { config } from './config';

export type PlanFeature = {
  code?: string;
  label?: string;
  feature_code?: string;
  featureCode?: string;
  feature_label?: string;
  featureLabel?: string;
  category?: string;
  enabled?: boolean;
};

export type SubscriptionPlan = {
  code: string;
  name: string;
  description?: string;
  monthly_price_usd?: number;
  monthlyPriceUsd?: number;
  annual_price_usd?: number;
  annualPriceUsd?: number;
  monthly_price_ngn?: number;
  monthlyPriceNgn?: number;
  annual_price_ngn?: number;
  annualPriceNgn?: number;
  max_members?: number | null;
  maxMembers?: number | null;
  highlight?: boolean;
  custom?: boolean;
  features?: PlanFeature[];
};

export type LeadPayload = {
  fullName: string;
  workEmail: string;
  phone?: string;
  organisationName: string;
  roleTitle?: string;
  cooperativeSize?: string;
  country?: string;
  message?: string;
  consent: true;
  page: string;
  referrer?: string;
  utm: Record<string, string>;
  website?: string;
};

const http = axios.create({ baseURL: config.apiBaseUrl, timeout: 20_000, headers: { Accept: 'application/json' } });

export function unwrap<T>(response: unknown): T {
  const value = response as { data?: { data?: T } | T };
  if (value?.data && typeof value.data === 'object' && 'data' in value.data) return value.data.data as T;
  return value?.data as T;
}

export async function getPublicPlans() {
  return unwrap<SubscriptionPlan[]>(await http.get('/public/subscription-plans')) || [];
}

export async function submitLead(payload: LeadPayload) {
  return unwrap<{ accepted: boolean; leadId?: string }>(await http.post('/public/marketing/leads', payload));
}

export function apiError(error: unknown, fallback: string) {
  if (axios.isAxiosError(error)) {
    const body = error.response?.data as { message?: string; detail?: string; correlationId?: string } | undefined;
    return { message: body?.message || body?.detail || (error.response ? fallback : 'We could not connect to CoopCore. Check your connection and try again.'), correlationId: body?.correlationId };
  }
  return { message: error instanceof Error ? error.message : fallback };
}
